/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWifi(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M12 5.251a15.25 15.25 0 00-10.084 3.81.75.75 0 11-.992-1.125 16.75 16.75 0 0122.152 0 .75.75 0 01-.992 1.125A15.25 15.25 0 0012 5.251zm.04 5c-2.397 0-4.718.84-6.56 2.374a.75.75 0 11-.96-1.153 11.75 11.75 0 0115.04 0 .75.75 0 11-.96 1.153 10.25 10.25 0 00-6.56-2.374zm-.035 4.999a5.25 5.25 0 00-3.04.97.75.75 0 01-.87-1.223 6.75 6.75 0 017.82 0 .75.75 0 01-.87 1.223 5.25 5.25 0 00-3.04-.97zm-.755 4.249a.75.75 0 01.75-.75h.01a.75.75 0 110 1.5H12a.75.75 0 01-.75-.75z'
      />
    </svg>
  );
}

export default SvgWifi;
